<div [formGroup]="form">
    <div class="row mt-2">        
        <div *ngIf="idiomas?.length > 0" class="col-4">
            <ca-form-field>
                <ca-label>{{'COMUN.DATOS_IDIOMA.SELECCION_IDIOMA' | translate}}</ca-label>
                <ca-select 
                    [options]="idiomas"
                    formControlName="codIdioma" 
                    keyValue="descIdioma"
                    valueField="codigoIdioma"></ca-select>
                <ca-error *ngIf="form.controls['codIdioma'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
            </ca-form-field>
        </div>
    </div>  
</div>